import { IRoute } from 'src/interfaces';
import AboutPage from 'src/modules/about';
import Dashboard from 'src/modules/dashboard';
import Login from 'src/modules/login';

import NotFound from 'src/modules/not-found';
import PasswordReset from 'src/modules/password-reset';
import ChangePassword from 'src/modules/change-password';
import PayHistory from 'src/modules/pay-history';
import EmployeeManagement from 'src/modules/employee-management';
import EmployeeListPage from 'src/modules/employee-list';
import Employee from 'src/modules/employee';
import MessageAndBulletinsManager from 'src/modules/message-manager';
import { YearEndForm } from 'src/modules/year-end-forms';
import FormsTable from 'src/modules/year-end-forms/forms-table-view/index';
import { FormTableEdit } from 'src/modules/year-end-forms/forms-table-view-edit/index';
import BenefitsPage from 'src/modules/benefits';
import EnrollmentHistoric from 'src/modules/benefits/components/enrollment-historic';
import { WorkerEnrolledBenefitsOld } from 'src/modules/reports/components/worker-enrolled-benefits-old';
import QleNewHireEnrollment from 'src/modules/benefits/components/qle-new-hire-enrollment';
import BenefitsManagementList from 'src/modules/benefits/components/benefits-management-list';
import EmployeeReviewChanges from 'src/modules/employee-review-changes';
import { ReportsPage } from 'src/modules/reports';
import { WorkerEnrolledBenefits } from 'src/modules/reports/components/worker-enrolled-benefits';
import { Settings } from 'src/modules/settings';
import { BenefitsVersionManagement } from 'src/modules/benefits/components/benefits-version-management';
import { BenefitRules } from 'src/modules/benefits/components/benefit-rules';
import { BenefitEditPage } from 'src/modules/benefits/components/benefit-edit-page';
import { BenefitPricePage } from 'src/modules/benefits/components/benefit-price-page';
import { BenefitPremiumPayoutConfig } from 'src/modules/benefits/components/benefit-premium-payout-config';
import { BenefitsConfigVersionContextWrapper } from 'src/modules/benefits/components/benefits-config-version';
import { WorkerEnrolledBenefitsNotEnrolled } from 'src/modules/reports/components/worker-not-enrolled-benefits';

import CreateInvoice from 'src/modules/invoice/createInvoice';
import CreateExpense from 'src/modules/expense/createExpense';
import EditExpense from 'src/modules/expense/editExpense';
import OverrideExpense from 'src/modules/expense/overrideExpense';
import ViewExpense from 'src/modules/expense/viewExpense';

import ViewInvoice from 'src/modules/invoice/viewInvoice';
import ViewInvoiceHistory from 'src/modules/invoice/viewInvoiceHistory';
import ViewExpenseHistory from 'src/modules/expense/viewExpenseHistory';
import EditInvoice from 'src/modules/invoice/editInvoice';
import OverrideInvoice from 'src/modules/invoice/overrideInvoice';
import InvoiceListPayProcess from 'src/modules/invoice/accounting/payProcessInvoice';
import InvoiceListBillProcess from 'src/modules/invoice/accounting/billProcessInvoices';
import ExpenseListBillProcess from 'src/modules/expense/accounting/billProcessExpense';
import ExpenseListPayProcess from 'src/modules/expense/accounting/payProcessExpense';
import MileageList from 'src/modules/mileage';
import Invoice from '../modules/invoice';
import Expense from '../modules/expense';
import SupportDesk from '../modules/support-desk';
import Faq from '../modules/faq';
import LeaveModule from '../modules/leave-module';
import SupportDeskDetail from '../modules/support-desk/support-ticket-detail';
import Newhirelist from '../modules/benefits/components/benefits-new-hire-list';

const routes: IRoute[] = [
  {
    path: '/',
    name: 'Login',
    element: Login,
    exact: true,
  },
  {
    path: '/employee',
    name: 'Employee',
    element: Employee,
    exact: true,
  },
  {
    path: '/employee/:activeTab',
    name: 'Employee',
    element: Employee,
    exact: true,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    element: Dashboard,
    exact: true,
  },
  {
    path: '/employee-management',
    name: 'Employee Management',
    element: EmployeeManagement,
    exact: true,
  },
  {
    path: '/employee-list',
    name: 'Employee List',
    element: EmployeeListPage,
    exact: true,
  },
  {
    path: '/employee-review-changes',
    name: 'Employee Changes',
    element: EmployeeReviewChanges,
    exact: true,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    element: PasswordReset,
    exact: true,
  },
  {
    path: '/about',
    name: 'About Page',
    element: AboutPage,
    exact: true,
  },
  {
    path: '/pay-history',
    name: 'Pay History',
    element: PayHistory,
    exact: true,
  },
  {
    path: '/change-password',
    name: 'Change Password Page',
    element: ChangePassword,
    exact: true,
  },
  {
    path: '/about/:id',
    name: 'About Page',
    element: AboutPage,
    exact: true,
  },
  {
    path: '*',
    name: 'Not found',
    element: NotFound,
    exact: true,
  },
  {
    path: '/message-bulletins-manager',
    name: 'Message and Bulletins Manager',
    element: MessageAndBulletinsManager,
    exact: true,
  },
  {
    path: '/workflow',
    name: 'Workflow',
    element: EmployeeReviewChanges,
    exact: true,
  },
  {
    path: '/year-end-forms',
    name: 'Year-end Forms',
    element: YearEndForm,
    exact: true,
  },
  {
    path: '/year-end-forms/:year/:formType',
    name: 'Year-end Forms',
    element: FormsTable,
    exact: true,
  },
  {
    path: '/year-end-forms/:year/:formType/:employeeId/:controlNumber',
    name: 'Year-end Forms',
    element: FormTableEdit,
    exact: true,
  },
  {
    path: '/benefits',
    name: 'Benefits',
    element: BenefitsPage,
    exact: true,
  },
  {
    path: '/benefits/edit/:benefitType',
    name: 'Benefits',
    element: BenefitsConfigVersionContextWrapper,
    exact: true,
  },
  {
    path: '/benefits/edit/prices/:versionId',
    name: 'Benefits Price and Premium config',
    element: BenefitEditPage,
    exact: true,
  },
  {
    path: '/benefits/open-enrollment',
    name: 'Open Enrollment Event',
    element: EnrollmentHistoric,
    exact: true,
  },
  {
    path: '/benefits/qle-enrollment',
    name: 'QLE Enrollment Event',
    element: QleNewHireEnrollment,
    exact: true,
  },
  {
    path: '/benefits/management',
    name: 'Benefits List',
    element: BenefitsManagementList,
    exact: true,
  },
  {
    path: '/benefits/version-management',
    name: 'Version Management',
    element: BenefitsVersionManagement,
    exact: true,
  },
  {
    path: '/benefit/rules',
    name: 'Benefit Rules',
    element: BenefitRules,
    exact: true,
  },
  {
    path: '/benefits/prices',
    name: 'Benefit Price',
    element: BenefitPricePage,
    exact: true,
  },
  {
    path: '/benefits/premium/:benefitType/:versionId',
    name: 'Benefit Premium Payout Config',
    element: BenefitPremiumPayoutConfig,
    exact: true,
  },
  {
    path: '/reports',
    name: 'Reports',
    element: ReportsPage,
    exact: true,
  },
  {
    path: '/reports/worker-enrolled-benefits',
    name: 'Reports',
    element: WorkerEnrolledBenefits,
    exact: true,
  },
  {
    path: '/reports/worker-enrolled-benefits-old',
    name: 'Reports',
    element: WorkerEnrolledBenefitsOld,
    exact: true,
  },
  {
    path: '/reports/worker-enrolled-benefits-notenrolled',
    name: 'Reports',
    element: WorkerEnrolledBenefitsNotEnrolled,
    exact: true,
  },
  {
    path: '/settings',
    name: 'Settings',
    element: Settings,
    exact: true,
  },
  {
    path: '/benefits/new-hires-list',
    name: 'New Hires List',
    element: Newhirelist,
    exact: true,
  },
  {
    path: '/support-desk',
    name: 'SupportDesk',
    element: SupportDesk,
    exact: true,
  },
  {
    path: '/faq',
    name: 'Faq',
    element: Faq,
    exact: true,
  },
  {
    path: '/invoices',
    name: 'Invoice',
    element: Invoice,
    exact: true,
  },
  {
    path: '/invoices/create',
    name: 'createInvoice',
    element: CreateInvoice,
    exact: true,
  },
  {
    path: '/invoices/:invoiceId/edit',
    name: 'editInvoice',
    element: EditInvoice,
    exact: true,
  },
  {
    path: '/invoices/:invoiceId/Override',
    name: 'OverrideInvoice',
    element: OverrideInvoice,
    exact: true,
  },
  {
    path: '/invoices/:invoiceId',
    name: 'viewInvoice',
    element: ViewInvoice,
    exact: true,
  },
  {
    path: '/invoices/:invoiceId/history',
    name: 'viewInvoiceHistory',
    element: ViewInvoiceHistory,
    exact: true,
  },
  {
    path: '/bill-process-invoices',
    name: 'billProcessInvoice',
    element: InvoiceListBillProcess,
    exact: true,
  },
  {
    path: '/pay-process-invoices',
    name: 'payProcessInvoice',
    element: InvoiceListPayProcess,
    exact: true,
  },
  {
    path: '/expenses',
    name: 'Expense',
    element: Expense,
    exact: true,
  },
  {
    path: '/expenses/create',
    name: 'createExpense',
    element: CreateExpense,
    exact: true,
  },
  {
    path: '/expenses/:expenseId/edit',
    name: 'editExpense',
    element: EditExpense,
    exact: true,
  },
  {
    path: '/expenses/:expenseId/Override',
    name: 'OverrideExpense',
    element: OverrideExpense,
    exact: true,
  },
  {
    path: '/expenses/:expenseId',
    name: 'viewExpense',
    element: ViewExpense,
    exact: true,
  },
  {
    path: '/expenses/:expenseId/history',
    name: 'vieExpenseHistory',
    element: ViewExpenseHistory,
    exact: true,
  },
  {
    path: '/bill-process-expense',
    name: 'billProcessInvoice',
    element: ExpenseListBillProcess,
    exact: true,
  },
  {
    path: '/pay-process-expense',
    name: 'payProcessInvoice',
    element: ExpenseListPayProcess,
    exact: true,
  },
  {
    path: '/clientmileage',
    name: 'Client & Mileage',
    element: MileageList,
    exact: true,
  },
  {
    path: '/leave',
    name: 'LeaveModule',
    element: LeaveModule,
    exact: true,
  },
  {
    path: '/ticket-detail/:ticketId',
    name: 'SupportDeskDetail',
    element: SupportDeskDetail,
    exact: true,
  },
];

export default routes;
